<template>
  <div>
    <Head :title="__('admin.settings')"/>
    <h1 class="h1">{{ __('admin.settings') }}</h1>
    <div class="flex items-center justify-between mb-6">
      <div class="column w-1/2">
        <form @submit.prevent="login">
          <div class="bg-white rounded-md shadow overflow-x-auto ">
            <div class="p-4">
              <h2 class="h2 mt-2">Generelle Einstellungen</h2>
              <div class="my-5">
                <label for="publish" class="inline-flex relative items-center cursor-pointer">
                  <input v-model="form.examlock" id="publish" type="checkbox" class="sr-only peer">
                  <div :class="toggleExamLock"
                       class="w-11 h-6 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"
                  ></div>
                  <span class="ml-3 text-sm font-medium text-gray-900">Prüfungsmodus aktivieren</span>
                </label>
                <p class="text-sm italic text-gray-500">Achtung! Der Prüfungsmodus sperrt alle Aktivitäten auf der
                  Webanwendung für Nicht-Mitarbeiter.</p>
              </div>

              <!-- write here the code for the other settings to edit the examlock message -->
              <div class="flex flex-col justify-content-end mb-2">
                <label for="examlock_message" class="block mb-2 text-sm font-medium text-secondary-500">Prüfungsnachricht (in HTML). </label>
                <textarea id="examlock_message" v-model="form.examlock_message" class="textarea" rows="5"></textarea>
              </div>

            </div>
            <div class="flex px-10 py-4 bg-gray-100 border-t border-gray-100">
              <loading-button :loading="form.processing" @click="submit" class="btn-primary ml-auto" type="submit">
                Einstellungen speichern
              </loading-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {Head} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    LoadingButton,
  },
  layout: Layout,
  props: {
    settings: Object,
  },

  // setup form from settings
  data() {
    return {
      form: this.$inertia.form({
        examlock: this.settings.examlock,
        examlock_message: this.settings.examlock_message,
      }),
    }
  },

  computed: {
    toggleExamLock() {
      return this.form.examlock ? 'bg-primary-600' : 'bg-gray-200'
    },
  },

  methods: {
    submit() {
      this.form.put('/admin/settings')
    },
  },
}
</script>
